import { useEffect } from "react";
import { useIntl } from "react-intl";
import { Scene } from "@ideastatica/scene/build/Types";

import CanvasRenderer from "./CanvasRenderer";
import { CrossIcon } from "../../assets/icons";

interface ScenePreviewOverlayProps {
  scene: Scene;
  sceneKey: string | number;
  onClose: () => void;
}

const ScenePreviewOverlay = ({ scene, sceneKey, onClose }: ScenePreviewOverlayProps) => {
  const intl = useIntl();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return (
    <div className="scene-overlay" onClick={onClose}>
      <div className="scene-overlay-content" onClick={(event) => event.stopPropagation()}>
        <div
          className="scene-overlay-close"
          onClick={onClose}
          role="button"
          tabIndex={0}
          title={intl.formatMessage({
            id: "MinimizePreview",
            defaultMessage: "Close enlarged view",
          })}
        >
          <CrossIcon />
        </div>
        <CanvasRenderer key={sceneKey} scene={scene} fullscreen />
      </div>
    </div>
  );
};

export default ScenePreviewOverlay;
